import { PurchaseCountry } from '@nemuru-eng/js-api-client';

import { PurchaseCountryWithFlag } from '../../../../../../shared/components/PurchaseCountryWithFlag';

export const AllowedPurchaseCountriesOptions = Object.values(PurchaseCountry).map((value) => ({
  value,
  display: <PurchaseCountryWithFlag purchaseCountry={value} />,
}));
